"use client";
import { styled } from "@mui/material/styles";
import { SpaceMd, SpaceLg } from "@nxt-costco-com/forge-design-tokens";
import { CostcoBox } from "../../Util/CostcoBox.js";
import { MOBILE_TILES_PER_ROW_ABOVE_THRESHOLD, MOBILE_TILES_PER_ROW_BELOW_THRESHOLD, TABLET_TILES_PER_ROW_ABOVE_THRESHOLD, TABLET_TILES_PER_ROW_BELOW_THRESHOLD, ITEM_THRESHOLD } from "./constants.js";
const mdImageContainerSx = (isPastItemThreshold) => {
  return isPastItemThreshold ? {
    width: `calc(100% / ${TABLET_TILES_PER_ROW_ABOVE_THRESHOLD} - ${SpaceMd} + ${16 / TABLET_TILES_PER_ROW_ABOVE_THRESHOLD}px)`
  } : {
    width: `calc(100% / ${TABLET_TILES_PER_ROW_BELOW_THRESHOLD} - ${SpaceMd} + ${16 / TABLET_TILES_PER_ROW_BELOW_THRESHOLD}px)`
  };
};
const smImageContainerSx = (isPastItemThreshold) => {
  return isPastItemThreshold ? {
    width: `calc(100% / ${MOBILE_TILES_PER_ROW_ABOVE_THRESHOLD} - ${SpaceMd} + ${16 / MOBILE_TILES_PER_ROW_ABOVE_THRESHOLD}px)`
  } : {
    width: `calc(100% / ${MOBILE_TILES_PER_ROW_BELOW_THRESHOLD} - ${SpaceMd} + ${16 / MOBILE_TILES_PER_ROW_BELOW_THRESHOLD}px)`
  };
};
const CategoryTileContainer = styled(CostcoBox, {
  shouldForwardProp: (prop) => prop !== "itemsPerRow"
})(({ itemsPerRow, theme }) => {
  const isPastItemThreshold = itemsPerRow > ITEM_THRESHOLD;
  return {
    display: "flex",
    justifyContent: "center",
    width: `calc(100% / ${itemsPerRow} - ${SpaceMd} + ${16 / itemsPerRow}px)`,
    [theme.breakpoints.down("lg")]: {
      ...mdImageContainerSx(isPastItemThreshold)
    },
    [theme.breakpoints.down("md")]: {
      ...smImageContainerSx(isPastItemThreshold)
    }
  };
});
const MultiRowContainer = styled(CostcoBox)(({ theme }) => ({
  display: "flex",
  alignItems: "flex-start",
  alignSelf: "stretch",
  flexWrap: "wrap",
  rowGap: SpaceLg,
  columnGap: SpaceMd,
  [theme.breakpoints.down("md")]: {
    rowGap: SpaceMd
  }
}));
export {
  CategoryTileContainer,
  MultiRowContainer
};
